import { createRouter, createWebHistory } from 'vue-router'
import AllFaqs from '../views/AllFaqs.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: AllFaqs,
    props: route => ({
      baseTitle: 'All FAQs',
      tag: route.query.tag ? route.query.tag : null
    })
  },
  {
    path: '/leads',
    name: 'leads',
    component: AllFaqs,
    props: route => ({
      customerGroup: 'lead',
      baseTitle: 'For Syndicate Leads',
      tag: route.query.tag ? route.query.tag : null
    })
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "leads" */ '../views/LeadFaqs.vue')
  },
  {
    path: '/lp',
    name: 'lp',
    component: AllFaqs,
    props: route => ({
      customerGroup: 'lp',
      baseTitle: 'For Angel Investors',
      tag: route.query.tag ? route.query.tag : null
    })
  },
  {
    path: '/founder',
    name: 'founder',
    component: AllFaqs,
    props: route => ({
      customerGroup: 'founder',
      baseTitle: 'For Founders',
      tag: route.query.tag ? route.query.tag : null
    })
  },
  // Detail display to only show one distinct FAQ.
  {
    path: '/id/:id',
    name: 'FaqDetail',
    component: AllFaqs,
    props: route => ({
      id: route.params.id
    }),
    meta: {
      title: 'FAQ Detail'
    }
  }
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  linkActiveClass: 'active',
  history: createWebHistory('/faqs'),
  routes
})

export default router
